;(function () {
    const btn = document.querySelector( '.site-navigation__high-contrast');
    let highContrastOn = document.cookie.split(';').some((item) => item.trim().startsWith('high-contrast-mode='));

    if ( ! btn ) {
        return;
    }

    btn.addEventListener( 'click', e => {
        e.preventDefault();
        document.body.classList.toggle( 'high-contrast-mode-on' );
        document.cookie = highContrastOn ?
            'high-contrast-mode=on;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/' :
            'high-contrast-mode=on;path=/';
        highContrastOn = ! highContrastOn;
    });
}());
